import moment from 'moment'

// Today's date and the time of day from one reading of the clock, in the
// formats the API uses for bookings (startDate 'YYYY-MM-DD', startTime
// 'HH:mm:ss'). Both are fixed-width, so comparing them with booking fields as
// plain strings orders them correctly.
export function clock () {
  const now = moment()
  return { date: now.format('YYYY-MM-DD'), time: now.format('HH:mm:ss') }
}
